import Vue from 'vue'
import VueResource from 'vue-resource'
import { container } from '../services/container'

import { plansStore } from '../store/plansStore' 

Vue.use(VueResource)

export class OrderApi {
	constructor () {
		this.url = process.env.VUE_APP_API_URL
	}

	getAccessToken()
	{
		return container.get('services.oauth').getToken()
	}

	updateOrCreate (token, vars) {
		if (token) {
			return this.update(token, vars)
		} else {
			return this.create(vars)
		}
	}

	create (params) {
		params.source = container.get('source').getValue('default')
		params.ref = container.get('services.cookies').get('ref', '/')
		params.aff_track = container.get('services.cookies').get('aff_track', '/')
		params.aff_source = container.get('services.cookies').get('aff_source', '/')
		params.__preserve = 0

		return Vue.http.post(this.url + '/order', params, { headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		}})
	}

	update (token, params) {
		return Vue.http.put(this.url + '/order/' + token, params, { headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		}})
	}

	confirm (order) {
		return Vue.http.post(this.url + '/order/' + order.token + '/confirm', {}, { headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		}})
	}

  delete (order) {
    return Vue.http.post(this.url + '/order/' + order.token + '/delete', {}, { headers: {
      Authorization: 'Bearer ' + this.getAccessToken()
    }})
  }

	preauthorization (token) {
		return Vue.http.post(this.url + '/order/' + token + '/preauthorization', {}, { headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		}})
	}

	confirmPreauthorization (token, params) {
		return Vue.http.post(this.url + '/order/' + token + '/confirm-preauthorization', params, { headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		}})
	}


	link (token) {
		return Vue.http.post(this.url + '/order/' + token + '/link', {}, { headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		}})
	}

	addCoupon (token, params) {
		return Vue.http.post(this.url + '/order/' + token + '/coupon', params, { headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		}})
	}

	removeCoupon (token, params) {
		return Vue.http.delete(this.url + '/order/' + token + '/coupon', { params, headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		}})
	}

	subscribeStripe (params) {
		return Vue.http.post(this.url + '/checkout/stripe/agreement', params, { headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		}})
	}
  
  createNewSetupIntent (params) {
    return Vue.http.post(this.url + '/checkout/stripe/create-intent', params, { headers: {
      Authorization: 'Bearer ' + this.getAccessToken()
    }})
  }

	intentStripe (params) {
		return Vue.http.post(this.url + '/checkout/stripe/intent', params, { headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		}})
	}

	confirmStripe (params) {
		return Vue.http.post(this.url + '/checkout/stripe/confirm', params, { headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		}})
	}

	askPaypal (params) {
		return Vue.http.post(this.url + '/checkout/paypal/ask', params, { headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		}})
	}

  confirmSetupStripe (params) {
    return Vue.http.post(this.url + '/checkout/stripe/confirm-setup', params, { headers: {
      Authorization: 'Bearer ' + this.getAccessToken()
    }})
  }

	confirmPaypal (params) {
		return Vue.http.post(this.url + '/checkout/paypal/confirm', params, { headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		}})
	}

	retrieve (token) {
		return Vue.http.get(this.url + '/order/' + token, { headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		}})
	}

	addRecipe (token, id) {
		return Vue.http.post(this.url + '/order/' + token + '/recipes/' + id, {}, { headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		}})
	}

	removeRecipe (token, id) {
		return Vue.http.delete(this.url + '/order/' + token + '/recipes/' + id, {}, { headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		}})
	}

	notify (token) {
		return Vue.http.post(this.url + '/order/' + token + '/notify', {}, { headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		}})
	}
};
